import { Feature } from '@tencent/workbench';
import { IChartDataLabelFeature } from '@tencent/chart-drawer-components/lib/interface';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { dataLabelPositionMapping } from '../utils';
import type {  STDLblPos } from '@tencent/chart-drawer-components/lib/interface';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import {
    IBaseDataLabelProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/data-label/data-label.interface';

@Feature({
    name: 'ChartDataLabelFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartDataLabelFeature,
})
export class ChartDataLabelFeature extends ChartBaseDrawerFeature implements IChartDataLabelFeature {
    public setDataLabelPosition(position: STDLblPos): void {
        this.dataLabelProperty?.updateProps({ labelPosition: dataLabelPositionMapping[position] });
    }

    /**
     * 设置是否在数据标签中包含系列名称
     */
    public setShouldContainSeriesName(value: boolean) {
        this.dataLabelProperty?.updateProps({ showSeriesName: value });
    }
    /**
     * 设置是否在数据标签中包含类别名称
     */
    public setShouldContainCategoryName(value: boolean) {
        this.dataLabelProperty?.updateProps({ showCategoryName: value });
    }
    /**
     * 设置是否在数据标签中包含值
     */
    public setShouldContainValue(value: boolean) {
        this.dataLabelProperty?.updateProps({ showVal: value });
    }
    /**
     * 设置是否在数据标签中包含百分比
     */
    public setShouldContainPercentage(value: boolean) {
        this.dataLabelProperty?.updateProps({ showPercent: value });
    }

    private get dataLabelProperty() {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return;

        return model.getSelectedElementProperty() as unknown as IBaseDataLabelProperty;
    }
}
